import { gql, useQuery } from '@apollo/client'
import { Box, StackDivider, VStack, Skeleton, Text, useColorModeValue } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
import { Deployment } from '../../../components'

const DEPLOYMENTS_QUERY = gql`
  query Deployments($appName: String!) {
    app(name: $appName) {
      id
      repoUrl
      deployments {
        id
        repoUrl
        branch
        status
        buildTime
        createdAt
        commitSha
        commitMessage
        authorLogin
        authorImg
      }
    }
  }
`

const Deployments = () => {
  const { name } = useParams()
  const borderColor = useColorModeValue('gray.300', 'whiteAlpha.300')
  const { data, loading } = useQuery(DEPLOYMENTS_QUERY, {
    variables: { appName: name },
    pollInterval: 5000,
  })

  const isLoading = !data || loading

  return (
    <Box p={4} rounded="lg" border="1px" borderColor={borderColor}>
      {!isLoading && !data?.app?.deployments?.length ? (
        <Text align="center">
          There are no deployments. <br />
          Deploy your app now either manually or by pushing to your default
          branch!
        </Text>
      ) : (
        <VStack
          divider={<StackDivider borderColor="gray.200" />}
          spacing={4}
          align="stretch"
        >
          {isLoading
            ? [0, 1, 2, 4, 5].map((i) => (
                <Skeleton key={i} h={8} rounded="md" />
              ))
            : data?.app?.deployments
                ?.slice()
                .sort(
                  (a: any, b: any) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
                )
                .map((deployment: any) => (
                  <Deployment
                    key={deployment.id}
                    deployment={deployment}
                    repoUrl={data?.app?.repoUrl}
                  />
                ))}
        </VStack>
      )}
    </Box>
  )
}

export default Deployments
